import React, { useEffect, useState } from 'react';
import { Typography } from '../../../../react/components/typography/typography';
import MagazinScroller from '../paywall-views/MagazineScroller';
import style from './cover-scroller-and-devices.module.scss';
import { PaywallTranslations } from '../paywall-comp';

const COVERS = [
  "https://d3ry4o1su9a59w.cloudfront.net/public/5809f9d8d9e840ed4800001e/58b8105903c6b7033c0000a5/643d05e62b852e0007c8de27/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5658382203c6b7a6ec000093/56583ca2d9e840fb6e0000ae/646f2dbde2b2ca2b6b435457/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5809f9d8d9e840ed4800001e/58b80f5003c6b7033c0000a4/646b6b79805dfd001b2e1d58/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5658382203c6b7a6ec000093/56583ac5d9e840fb6e0000ac/64199dd0e2b2ca05583e0828/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5c90a5b703c6b72a9153c1ef/59ba9de6d9e8403b980000f7/6477eb3ce2b2ca2b6b436f86/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5b928634d9e84082790000cb/5a280e4f03c6b7c0c700016b/645b6d9bcb3476309e6b8248/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/53f3345edaafd02b54000008/546a1b97daafd0b105000001/6453cf5be2b2ca2b6b42efe7/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5658382203c6b7a6ec000093/56584072d9e84086140000c8/6435215bbcc0460020b85720/2/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5809f9d8d9e840ed4800001e/5818c7ba03c6b78709000055/642e8dd28c84e0000823f299/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/5658382203c6b7a6ec000093/56583e5a03c6b7d8a50000d5/63b6b5d5e2b2ca05583c95ce/1/432-0001.jpg",
  "https://d3ry4o1su9a59w.cloudfront.net/public/635a9527891550000bbb5497/639890d14539360008d4d4fc/647707d231fb2375211893e1/1/432-0001.jpg",
]

export const CoverScrollerAndDevices = ({
  topPublications,
  translations
}: {
  topPublications: [],
  translations: PaywallTranslations
}) => {

  const [topCovers, setTopCovers] = useState(null);
  const [bottomCovers, setBottomCovers] = useState(null);

  console.log(topPublications)

  useEffect(() => {
    if (topPublications.length < 20) {
      setTopCovers(COVERS);
      setBottomCovers(COVERS);
    } else {
      const firstHalf = topPublications.slice(0, Math.ceil(topPublications.length / 2))
      const secondHalf = topPublications.slice(Math.ceil(topPublications.length / 2), topPublications.length)

      setTopCovers(firstHalf);
      setBottomCovers(secondHalf);
    }
  }, [topPublications])

  if (!topCovers || !bottomCovers) {
    return null;
  }

  return (
    <>
      <div style={{ marginTop: '32px' }}>
        <div style={{ margin: '0 auto', maxWidth: '462px', width: '100%', padding: '0 16px' }}>
          <Typography element={'div'} themeColor={'text-ink-offset'} textSize={'sys-title-medium'} style={{ textAlign: 'left', marginBottom: '16px', padding: '0px' }}>
            {translations['lokalise.catalog.article_paywall.read_on']}
          </Typography>
        </div>
        <div style={{ position: 'relative' }}>
          <div className={style.scrollerGradientLeft} />
          <MagazinScroller imageURLs={topCovers} height={127} animationTime={15} />
          <div className={style.scrollerGradientRight} />
        </div>
        <div style={{ position: 'relative', marginTop: '16px' }}>
          <div className={style.scrollerGradientLeft} />
          <MagazinScroller direction='reverse' imageURLs={bottomCovers} height={127} animationTime={15} />
          <div className={style.scrollerGradientRight} />
        </div>
      </div>
    </>
  )
}
